import { RoleEnum } from './role.constant';

export const ROUTERS = {
	GUIDE: '/guide',
	LOGIN: '/', // lp1-01
	VERIFY: '/verify', // OTP verification
	MAIN: '/',

	SYSTEM: '/system',
	WORKER: '/worker',
	FOREIGN: '/foreign',
	MP1_01: '/mp1-01',

	UM1_01: '/system/um1-01',
	UM1_02: '/system/um1-01/create',
	UM1_03: '/system/um1-01/:id',
	CM1_01: '/system/sub-cm/cm1-01',
	CM1_02: '/system/sub-cm/cm1-01/create',
	CM1_03: '/system/sub-cm/cm1-01/:id',
	CM2_01: '/system/sub-cm/cm2-01',
	CM2_02: '/system/sub-cm/cm2-01/create',
	CM2_03: '/system/sub-cm/cm2-01/:id',
	SM1_01: '/system/sm1-01',
	SM1_02: '/system/sm1-01/create',
	SM1_03: '/system/sm1-01/:id',

	ED1_01: '/worker/ed1-01',
	SUB_WORKER_BASIC_INFO: '/worker/sub-worker-basic-info',
	FM1_01: '/worker/sub-worker-basic-info/fm1-01',
	US1_01: '/worker/sub-worker-basic-info/us1-01',
	MM1_01: '/worker/sub-worker-basic-info/mm1-01',
	MM1_02: '/worker/sub-worker-basic-info/mm1-01/create',
	MM1_03: '/worker/sub-worker-basic-info/mm1-01/:id',
	AR1_01: '/worker/ar1-01',
	AR1_02: '/worker/ar1-01/create',
	AR1_03: '/worker/ar1-01/:id',
	FR1_01: '/worker/fr1-01',
	FR1_02: '/worker/fr1-01/create',
	FR1_03: '/worker/fr1-01/:id',
	RM1_01: '/worker/rm1-01',
	RM1_02: '/worker/rm1-01/create',
	RM1_03: '/worker/rm1-01/:id',
	LM1_01: '/worker/lm1-01',
	LM1_02: '/worker/lm1-01/create',
	LM1_03: '/worker/lm1-01/:id',
	PM1_01: '/worker/sub-pm/pm1-01',
	PM1_02: '/worker/sub-pm/pm1-01/create',
	PM1_03: '/worker/sub-pm/pm1-01/:id',
	PM2_01: '/worker/sub-pm/pm2-01',
	AM1_01: '/worker/sub-am/am1-01',
	AM1_03: '/worker/sub-am/am1-01/:id',
	AM3_01: '/worker/sub-am/am3-01',
	PA1_01: '/worker/sub-pa/pa1-01',
	PA1_03: '/worker/sub-pa/pa1-01/:id',
	PA2_01: '/worker/sub-pa/pa2-01',
	PA3_01: '/worker/sub-pa/pa3-01',
	PA3_03: '/worker/sub-pa/pa3-01/:id',
	PA4_01: '/worker/sub-pa/pa4-01',
	EM1_01: '/worker/em1-01',
	EM1_02: '/worker/em1-01/create',
	EM1_03: '/worker/em1-01/:id',
	DM1_01: '/worker/dm1-01',
	WC1_01: '/worker/wc1-01',
	WC1_02: '/worker/wc1-01/create',
	WC1_03: '/worker/wc1-01/:id',
	BM1_01: '/worker/bm1-01',
	BM1_02: '/worker/bm1-01/create',
	BM1_03: '/worker/bm1-01/:id',
	ST1_01: '/worker/st1-01',
	ST1_03: '/worker/st1-01/:id',
	WH1_01: '/worker/wh1-01',

	OD1_01: '/foreign/od1-01',
	SUB_FOREIGN_BASIC_INFO: '/foreign/sub-foreign-basic-info',
	OI1_01: '/foreign/sub-foreign-basic-info/oi1-01',
	OI2_01: '/foreign/sub-foreign-basic-info/oi2-01',
	OI2_02: '/foreign/sub-foreign-basic-info/oi2-01/create',
	OI2_03: '/foreign/sub-foreign-basic-info/oi2-01/:id',
	OR1_01: '/foreign/or1-01',
	OR1_02: '/foreign/or1-01/create',
	OR1_03: '/foreign/or1-01/:id',
	OP1_01: '/foreign/op1-01',
	OP1_03: '/foreign/op1-01/:id',

	SUB_SYSTEM_NOTICE_INQUIRY_BOARD: '/system/sub-notice-inquiry-board',
	SUB_WORKER_NOTICE_INQUIRY_BOARD: '/worker/sub-notice-inquiry-board',
	SUB_FOREIGN_NOTICE_INQUIRY_BOARD: '/foreign/sub-notice-inquiry-board',
	NM1_01: (path: string) => `${path}/nm1-01`,
	NM1_02: (path: string) => `${path}/nm1-01/create`,
	NM1_03: (path: string) => `${path}/nm1-01/:id`,
	NP1_01: (path: string) => `${path}/np1-01`,
	NP1_03: (path: string) => `${path}/np1-01/:id`,
	BBM1_01: (path: string) => `${path}/bbm1-01`,
	BBM1_03: (path: string) => `${path}/bbm1-01/:id`,
	BB1_01: (path: string) => `${path}/bb1-01`,
	BB1_02: (path: string) => `${path}/bb1-01/create`,
	BB1_03: (path: string) => `${path}/bb1-01/:id`,

	AU1_01: (path: string) => `${path}/au1-01`,

	// for mobile web
	LM2_01: '/worker/lm2-01',
	DM1_02: '/worker/dm1-02',
	DM1_02_02: '/worker/dm1-02-02',
	DM1_02_03: '/worker/dm1-02-03',
	DM1_02_05: '/worker/dm1-02-05',
	DM1_03: '/worker/dm1-01/:id',
	DD1_01: '/worker/download-document',
	P_DM1_2: '/worker/p-dm1-2',
	MSLP: '/worker/m-select-lodging-popup',

	// Other
	DEFINE_DOCUMENT_UPLOAD: '/worker/define-document-upload',
	DEFINE_ASSIGNMENT: '/worker/define-assignment',
	ISSUE_APPLICATION_DOWNLOAD: '/worker/issue-application-download',
	DEFINE_PUBLIC_ASSIGNMENT: '/worker/define-public-assignment',

	// OAuth
	OAUTH_CALLBACK: '/oauth/callback',

	// Dev
	DEV_01: '/worker/dev-01',
	DEV_03: '/worker/dev-03',
	DEV_08: '/worker/dev-08',
	DEV_09: '/worker/dev-09',

	// Tablet (public - no login required)
	TAB_01: '/tab-01',
	TAB_02: '/tab-02',

	// Mobile (public - no login required)
	MOB_01: '/mob-01',
	MOB_02: '/mob-02',
	MOB_03: '/mob-03',
	MOB_04: '/mob-04',

	// Tablet login
	TAB_03: '/tab-03',
};

export enum RoutesCodeEnum {
	LOGOUT = 'LOGOUT',
	SYSTEM = 'SYSTEM',
	WORKER = 'WORKER',
	FOREIGN = 'FOREIGN',
	UM1_01 = 'UM1_01',
	UM1_02 = 'UM1_02',
	UM1_03 = 'UM1_03',
	SUB_CM = 'SUB_CM',
	CM1_01 = 'CM1_01',
	CM1_02 = 'CM1_02',
	CM1_03 = 'CM1_03',
	CM2_01 = 'CM2_01',
	CM2_02 = 'CM2_02',
	CM2_03 = 'CM2_03',
	SM1_01 = 'SM1_01',
	SM1_02 = 'SM1_02',
	SM1_03 = 'SM1_03',

	ED1_01 = 'ED1_01',
	SUB_WORKER_BASIC_INFO = 'SUB_WORKER_BASIC_INFO',
	FM1_01 = 'FM1_01',
	US1_01 = 'US1_01',
	MM1_01 = 'MM1_01',
	MM1_02 = 'MM1_02',
	MM1_03 = 'MM1_03',
	AR1_01 = 'AR1_01',
	AR1_02 = 'AR1_02',
	AR1_03 = 'AR1_03',
	FR1_01 = 'FR1_01',
	FR1_02 = 'FR1_02',
	FR1_03 = 'FR1_03',
	RM1_01 = 'RM1_01',
	RM1_02 = 'RM1_02',
	RM1_03 = 'RM1_03',
	LM1_01 = 'LM1_01',
	LM1_02 = 'LM1_02',
	LM1_03 = 'LM1_03',
	SUB_PM = 'SUB_PM',
	PM1_01 = 'PM1_01',
	PM1_02 = 'PM1_02',
	PM1_03 = 'PM1_03',
	PM2_01 = 'PM2_01',
	SUB_AM = 'SUB_AM',
	AM1_01 = 'AM1_01',
	AM1_03 = 'AM1_03',
	AM3_01 = 'AM3_01',
	SUB_PA = 'SUB_PA',
	PA1_01 = 'PA1_01',
	PA1_03 = 'PA1_03',
	PA2_01 = 'PA2_01',
	PA3_01 = 'PA3_01',
	PA3_03 = 'PA3_03',
	PA4_01 = 'PA4_01',
	EM1_01 = 'EM1_01',
	DM1_01 = 'DM1_01',
	WC1_01 = 'WC1_01',
	WC1_02 = 'WC1_02',
	WC1_03 = 'WC1_03',
	BM1_01 = 'BM1_01',
	BM1_02 = 'BM1_02',
	BM1_03 = 'BM1_03',
	ST1_01 = 'ST1_01',
	ST1_03 = 'ST1_03',
	MP1_01 = 'MP1_01',
	DOCUMENT_AREA = 'DOCUMENT_AREA',

	OD1_01 = 'OD1_01',
	SUB_FOREIGN_BASIC_INFO = 'SUB_FOREIGN_BASIC_INFO',
	OI1_01 = 'OI1_01',
	OI2_01 = 'OI2_01',
	OR1_01 = 'OR1_01',
	OP1_01 = 'OP1_01',
	SUB_NOTICE_INQUIRY_BOARD = 'SUB_NOTICE_INQUIRY_BOARD',
	NM1_01 = 'NM1_01',
	NM1_02 = 'NM1_02',
	NM1_03 = 'NM1_03',
	NP1_01 = 'NP1_01',
	NP1_02 = 'NP1_02',
	NP1_03 = 'NP1_03',
	BBM1_01 = 'BBM1_01',
	BBM1_03 = 'BBM1_03',
	BBM1_03_1 = 'BBM1_03_1',
	BB1_01 = 'BB1_01',
	BB1_02 = 'BB1_02',
	BB1_03 = 'BB1_03',
	WH1_01 = 'WH1_01',
	AU1_01 = 'AU1_01',
	SUB_DEV = 'SUB_DEV',
	DEV_01 = 'DEV_01',
	DEV_03 = 'DEV_03',
	DEV_08 = 'DEV_08',
	DEV_09 = 'DEV_09',
}

export enum RoutesNameEnum {
	LOGOUT = '로그아웃',
	SYSTEM = '시스템 관리',
	WORKER = '계절근로관리',
	FOREIGN = '외국의',
	UM1_01 = '시스템 관리자',
	UM1_02 = '시스템 관리자 등록',
	UM1_03 = '시스템 관리자 상세',
	SUB_CM = '사업체 관리',
	CM1_01 = '국내 사업체',
	CM1_02 = '국내 사업체 등록',
	CM1_03 = '국내 사업체 상세',
	CM2_01 = '해외 사업체',
	CM2_02 = '해외 사업체 등록',
	CM2_03 = '해외 사업체 상세',
	SM1_01 = '서비스 사용 Tip 관리',

	ED1_01 = '대시보드',
	SUB_FM_US_MM = '기초정보',
	FM1_01 = '사업체 정보',
	US1_01 = '사업체 설정 관리',
	MM1_01 = '관리자 관리',
	MM1_02 = '관리자 등록',
	MM1_03 = '관리자 상세',
	AR1_01 = '근로자 관리',
	AR1_02 = '근로자 등록',
	AR1_03 = '근로자 상세',
	FR1_01 = '사업장 관리',
	FR1_02 = '사업장 등록',
	FR1_03 = '사업장 상세',
	RM1_01 = '추천자 관리',
	RM1_02 = '추천자 등록',
	RM1_03 = '추천자 상세',
	LM1_01 = '숙소 관리',
	LM1_02 = '숙소 등록',
	LM1_03 = '숙소 상세',
	SUB_PM = '프로그램 관리',
	PM1_01 = '프로그램 조회/등록',
	PM1_02 = '프로그램 등록',
	PM1_03 = '프로그램 상세',
	PM2_01 = '프로그램 현황',
	SUB_AM = '일반(농가) 배정 관리',
	AM1_01 = '일반(농가) 배정',
	AM1_03 = '일반(농가) 배정 상세',
	AM3_01 = '일반(농가) 배정 현황',
	SUB_PA = '공공형 관리',
	PA1_01 = '공공형 배정',
	PA1_03 = '공공형 배정 상세',
	PA2_01 = '공공형 캘린더',
	PA3_01 = '공공형 운영 현황',
	PA3_03 = '공공형 운영 현황 상세',
	PA4_01 = '공공형 급여 관리',
	EM1_01 = '체류연장',
	DM1_01 = '서류 관리',
	WC1_01 = '근무처변경',
	WC1_02 = '근무처변경 등록',
	WC1_03 = '근무처변경 상세',
	BM1_01 = '무단이탈',
	BM1_02 = '무단이탈 등록',
	BM1_03 = '무단이탈 상세',
	ST1_01 = '서비스 사용 Tip',
	ST1_03 = '서비스 사용 Tip 상세',
	MP1_01 = '내 정보 관리',
	DOCUMENT_AREA = '서류 정보',
	WH1_01 = '작업 이력',
	DEV_01 = '모바일 기기 관리',
	DEV_03 = '태블릿 관리',
	DEV_08 = '기기 접속 로그',
	SUB_DEV = '기기 관리',

	OD1_01 = 'Dashboard',
	SUB_OI = 'Basic Information',
	OI1_01 = 'Business Information',
	OI2_01 = 'Administrator Management',
	OI2_02 = 'Administrator Registration',
	OI2_03 = 'Administrator Details',
	OR1_01 = 'Worker Management',
	OR1_02 = 'Worker Registration',
	OP1_01 = 'Program Management',

	NM1_01 = 'NM1_01',
	NM1_02 = 'NM1_02',
	NM1_03 = 'NM1_03',
	NP1_01 = 'NP1_01',
	NP1_02 = 'NP1_02',
	NP1_03 = 'NP1_03',
	BBM1_01 = 'BBM1_01',
	BBM1_03 = 'BBM1_03',
	BBM1_03_1 = 'BBM1_03_1',
	BB1_01 = 'BB1_01',
	BB1_02 = 'BB1_02',
	BB1_03 = 'BB1_03',

	AU1_01 = '접근 및 이용 이력',

	FOOTER_INFO = 'Footer 정보',
	CONTRACTED_FOREIGN_BUSINESS = '계약된 해외 사업체',
	DISTRICT_ALLOW_IP = '읍/면 허용 IP',
}

export const MAIN_PAGE = {
	[RoleEnum.SYS_ADMIN]: ROUTERS.UM1_01,
	[RoleEnum.MASTER_ADMIN]: ROUTERS.ED1_01,
	[RoleEnum.SUPER_ADMIN]: ROUTERS.ED1_01,
	[RoleEnum.ADMIN]: ROUTERS.ED1_01,
	[RoleEnum.PUBLIC_ADMIN]: ROUTERS.ED1_01,
	[RoleEnum.FOREIGN_MASTER_ADMIN]: ROUTERS.OD1_01,
	[RoleEnum.FOREIGN_ADMIN]: ROUTERS.OD1_01,
};

export const ROUTERS_HIDDEN_KEY = {
	[RoleEnum.SYS_ADMIN]: [],
	[RoleEnum.MASTER_ADMIN]: [],
	[RoleEnum.SUPER_ADMIN]: [],
	[RoleEnum.ADMIN]: [
		ROUTERS.FM1_01,
		ROUTERS.US1_01,
		ROUTERS.AU1_01(ROUTERS.WORKER),
	],
	[RoleEnum.PUBLIC_ADMIN]: [
		ROUTERS.FM1_01,
		ROUTERS.US1_01,
		ROUTERS.RM1_01,
		ROUTERS.LM1_01,
		ROUTERS.PM1_01,
		ROUTERS.PM2_01,
		ROUTERS.WC1_01,
		ROUTERS.BM1_01,
		ROUTERS.DM1_01,
		ROUTERS.NM1_01(ROUTERS.SUB_WORKER_NOTICE_INQUIRY_BOARD),
		ROUTERS.BBM1_01(ROUTERS.SUB_WORKER_NOTICE_INQUIRY_BOARD),
		ROUTERS.AM1_01,
		ROUTERS.AM3_01,
		ROUTERS.AU1_01(ROUTERS.WORKER),
	],
	[RoleEnum.FOREIGN_MASTER_ADMIN]: [],
	[RoleEnum.FOREIGN_ADMIN]: [],
};

export const ROUTERS_COMMON_MENU_LABELS = {
	[RoleEnum.SYS_ADMIN]: {
		[ROUTERS.NM1_01(ROUTERS.SUB_SYSTEM_NOTICE_INQUIRY_BOARD)]:
			RoutesNameEnum.NP1_01,
		[ROUTERS.BBM1_01(ROUTERS.SUB_SYSTEM_NOTICE_INQUIRY_BOARD)]:
			RoutesNameEnum.BB1_01,
	},
} as Record<RoleEnum, Record<string, string>>;

export const ROUTERS_COMMON_DOCUMENT_TITLES = {
	[RoleEnum.SYS_ADMIN]: {
		[RoutesCodeEnum.NM1_01]: RoutesNameEnum.NP1_01,
		[RoutesCodeEnum.NM1_02]: RoutesNameEnum.NP1_02,
		[RoutesCodeEnum.NM1_03]: RoutesNameEnum.NP1_03,
		[RoutesCodeEnum.BBM1_01]: RoutesNameEnum.BB1_01,
		[RoutesCodeEnum.BBM1_03]: RoutesNameEnum.BBM1_03_1,
	},
} as unknown as Record<RoleEnum, Record<string, string>>;
